import React from 'react';
import { Facebook, Instagram, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-sunrise-brown-dark text-sunrise-cream-dark pt-16 pb-8" data-id="element-65">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-67">
          {/* Brand */}
          <div data-id="element-68">
            <img src="https://cdn.magicpatterns.com/uploads/pNNk2ceH6mKBZ3qz1gUZLh/Sunrise-door-logo.png" alt="Sunrise Door n Trim" className="h-20 w-auto mb-4" data-id="element-69" />
            <p className="text-sm leading-relaxed mb-6 opacity-80" data-id="element-70">
              Professional finish carpentry services for Arizona's finest homes.
              Quality craftsmanship you can trust.
            </p>
            <div className="inline-block border border-sunrise-gold/30 rounded px-3 py-1 text-xs font-medium text-sunrise-gold" data-id="element-71">
              ROC #363248
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-72">
            <h4 className="font-bold text-white mb-4 uppercase tracking-wider text-sm" data-id="element-73">
              Quick Links
            </h4>
            <ul className="space-y-2" data-id="element-74">
              {['Services', 'Our Work', 'About', 'Contact'].map(item => <li key={item} data-id="element-75">
                  <a href={`#${item.toLowerCase().replace(' ', '-')}`} className="text-sm hover:text-sunrise-orange transition-colors" data-id="element-76">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-77">
            <h4 className="font-bold text-white mb-4 uppercase tracking-wider text-sm" data-id="element-78">
              Service Areas
            </h4>
            <ul className="space-y-2 text-sm opacity-80" data-id="element-79">
              <li data-id="element-80">Gilbert</li>
              <li data-id="element-81">Phoenix</li>
              <li data-id="element-82">Mesa</li>
              <li data-id="element-83">Chandler</li>
              <li data-id="element-84">Scottsdale</li>
              <li data-id="element-85">Queen Creek</li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-86">
            <h4 className="font-bold text-white mb-4 uppercase tracking-wider text-sm" data-id="element-87">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-88">
              <li className="flex items-center" data-id="element-89">
                <Phone className="w-4 h-4 mr-3 text-sunrise-orange" data-id="element-90" />
                <a href="tel:6026326929" className="hover:text-white transition-colors" data-id="element-91">
                  602-632-6929
                </a>
              </li>
              <li className="flex items-center" data-id="element-92">
                <Mail className="w-4 h-4 mr-3 text-sunrise-orange" data-id="element-93" />
                <a href="mailto:info@sunrisedoorntrim.com" className="hover:text-white transition-colors" data-id="element-94">
                  info@sunrisedoorntrim.com
                </a>
              </li>
            </ul>
            <div className="flex space-x-4 mt-6" data-id="element-95">
              <a href="#" className="text-white/60 hover:text-sunrise-orange transition-colors" data-id="element-96">
                <Facebook className="w-5 h-5" data-id="element-97" />
              </a>
              <a href="#" className="text-white/60 hover:text-sunrise-orange transition-colors" data-id="element-98">
                <Instagram className="w-5 h-5" data-id="element-99" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs opacity-60" data-id="element-100">
          <p data-id="element-101">© 2026 Sunrise Door n Trim. All rights reserved.</p>
          <p className="mt-2 md:mt-0" data-id="element-102">Licensed, Bonded & Insured</p>
        </div>
      </div>
    </footer>;
}